export class VnskySupportAlertToken {
  static VnskySupportAlertViewModel = Symbol("VnskySupportAlertViewModel");
  static IAlertSupportRepository = Symbol("IAlertSupportRepository");
  static AlertSupportUseCase = Symbol("AlertSupportUseCase");
}
